import React, { useState} from 'react';
import { Field, FieldWrapper } from '@progress/kendo-react-form';
import { nametoAppearValidator, reqDDLValidator } from '../validation/Validators';
import bizBankingData from '../data/bizbankingservicedata.json'
 
import { CusFormComboBox, CusFormInput } from '../validation/Form-Components';
import CusAddBtn from '../components/CusAddBtn';
import CusRemoveBtn from '../components/CusRemoveBtn';

const BizCardApplicant = (props) => {
    const {seq, cboData, cboTxtField, displayAddRemoveBtn, defBtnValue, maxlength}  = props;

    const [showAddBtn,setShowAddBtn] = useState(defBtnValue);

    const handleOnChange = (e) => {
        props.onCboChange(e);
    }

    const addBtnClick = (e) => {
 
        setShowAddBtn(false);
        props.AddBtnOnClick();
    }

    const removeBtnClick = (e) => {
 
        let value = true;
        setShowAddBtn(value);
        props.RemoveBtnOnClick();
 
    }
    
    const handleOnInputChange = (e) => {
        props.onInputChange(e.value,'NametoAppear'+seq);
    }

    return(
   
    <FieldWrapper>
        <Field component={CusFormComboBox} 
            leftLabelId={'lblApplicantCbo'+seq} leftLabelName={bizBankingData.label.dcApplicant+' '+seq}
            id={'ApplicantCbo'+seq} name={'ApplicantCbo'+seq}
            textField={cboTxtField} 
            data={cboData}
            onChange={handleOnChange}
            placeholder={'Please select'} 
            validator={reqDDLValidator} />
 
        <Field component={CusFormInput} 
            leftLabelId={'lblNametoAppear'+seq} leftLabelName={bizBankingData.label.nOnCard} 
            id={'NametoAppear'+seq} name={'NametoAppear'+seq} placeholder={'Please input'} 
            maxLength={maxlength} 
            validator={nametoAppearValidator} 
            onChange={handleOnInputChange} />


        {displayAddRemoveBtn && <div>
        {showAddBtn? <CusAddBtn id={'AddBtn'+seq} label={'Add another applicant'} disabled={false} onClick={addBtnClick}/>:
        <CusRemoveBtn id={'RemoveBtn'+seq} label={'REMOVE'} disabled={false} onClick={removeBtnClick}  />}</div>}

    
    </FieldWrapper>
 
    )
}


export default BizCardApplicant;